export const redirectOnTrialFirstLogin = (user) => {
  const MAX_LOGIN_COUNT = 1

  const isFirstLogin = user.loginsCount === MAX_LOGIN_COUNT
  const needsRedirect = user.isFreeTrial && isFirstLogin

  return !!needsRedirect
}
